import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import fr from './locales/fr.json';
import en from './locales/en.json';

// 26/09 (Marlon : « j'ai lance le tour sur le compte demo et c'etait en anglais »).
// Jusqu'a ce matin, la langue etait DETECTEE depuis le navigateur puis ECRITE dans
// localStorage (« caches »). Retirer « navigator » de la detection ne suffit donc pas :
// tous ceux qui ont ouvert le site avant gardent « en » fige pour toujours. Et comme le
// tableau de bord est ecrit en francais EN DUR, seul ce qui passe par i18n basculait —
// le menu restait francais pendant que le guide s'affichait en anglais.
// On remet donc le choix a zero UNE seule fois. Un choix fait ensuite avec le bouton
// FR/EN est respecte : il reecrit la cle, et ce nettoyage ne repasse jamais.
const CLE_REMISE_A_ZERO = 'chathub-lang-defaut-fr-2609';
try {
  if (!localStorage.getItem(CLE_REMISE_A_ZERO)) {
    localStorage.removeItem('chathub-lang');
    localStorage.setItem(CLE_REMISE_A_ZERO, '1');
  }
} catch (e) {
  // navigation privee ou stockage bloque : on laisse le repli sur « fr » faire son travail
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: 'fr',
    supportedLngs: ['en', 'fr'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'chathub-lang',
    },
  });

export default i18n;
